import store from '@/store';
export default {
    //同云盘剪切粘贴数据格式封装
    movePasteData: function(ud, dd, pid, id, tid, n, pathJson,dir) {
        this.ud = ud;
        this.dd = dd;
        this.pid = pid;
        this.id = id;
        this.tid = tid;
        this.n = n;
        if(pathJson){
        this.pathJson = pathJson;
        }
        this.dir=dir;
    },
    getDiveData(ud, id) {
        this.ud = ud;
        this.id = id;
    },
    fileSearchData(ud, dd, kw) {
        this.ud = ud;
        this.dd = dd;
        this.kw = kw;
    },
    //列出文件列表
    filelistData(id, ud, dd, offset, limit, nextPage) {
        this.id = id;
        this.ud = ud;
        this.dd = dd;
        if (offset || offset == 0) {
            this.offset = offset;
        }
        if (limit) {
            this.limit = limit;
        }
        if (nextPage) {
            this.nextPage = nextPage;
        }

    },
    //列出邮件列表
    emaillistData(id, ud, dd, docType,limit,nextPage, queryParameter) {
        this.id = id;
        this.ud = ud;
        this.dd = dd;
        if (docType) {
            this.docType = docType;
        }
        if (limit) {
            this.limit = limit;
        }
        if (nextPage) {
            this.nextPage = nextPage;
        }
        if (queryParameter) {
            this.queryParameter = queryParameter;
        }
    },
    recycleData(ud, dd) {
        this.ud = ud;
        this.dd = dd;
        this.limit = 500;
    },
    deleteData(id, ud, dd, pid, dir, tsh) {
        this.id = id;
        this.ud = ud;
        this.dd = dd;
        this.pid = pid;
        this.dir = dir;
        this.tsh = tsh;
    },
    restoreData(ud, dd, pid, id, dir) {
        this.ud = ud;
        this.dd = dd;
        this.pid = pid;
        this.id = id;
        this.dir = dir;
    },
    emptyTrashData(ud, dd) {
        this.ud = ud;
        this.dd = dd;
    },
    goOfficialSiteData(ud, dd, pid, id){
        this.ud = ud;
        this.dd = dd;
        this.pid = pid;
        this.id = id;
    },
    previewData(ud,dd,id,n){
        this.ud = ud;
        this.dd = dd;
        this.id = id;
        this.n=n;
    },
    mkdirData(tid,ud,dd,n){
        this.tid=tid;
        this.ud = ud;
        this.dd = dd;
        this.n=n;
    },
    reName(id,ud,dd,n,dir){
       this.id=id;
       this.ud=ud;
       this.dd=dd;
       this.n=n;
       this.dir=dir;
    },
    newItem(name,dir,driveId,pid){
        this.name=name;
        this.dir=dir;
        this.driveId=driveId;
        this.pid=pid;
    },
    downloadData(ud,dd,id,n){
       this.ud=ud;
       this.dd=dd;
       this.id=id;
       this.n=n;
    },
    uploadData(ud,dd,tid,n){
        this.ud=ud;
        this.dd=dd;
        this.tid=tid;
        this.n=n;
    },
    cancelAllData(ud,type,bh){
        this.ud=ud;
        this.type=type;
        this.bh=bh;
    },
    listData(id,ud,dd){
       this.id=id;
       this.ud=ud;
       this.dd=dd;
    },
    removeData(ud,type,wd){
      this.ud=ud;
      this.type=type;
      this.wd=wd;
    },
    cancelData(ud,type,id,wd){
     this.ud=ud;
     this.type=type;
     this.id=id;
     this.wd=wd;
    }


}


// WEBPACK FOOTER //
// ./src/js/workspace/cloud_exploer_util.js